import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

const RATINGS = [1, 2, 3, 4, 5] as const;

interface StarRowProps {
  /** 1-5; fractional averages fill to the nearest whole star. */
  value: number;
  label: string;
  className?: string;
}

/** A read-only row of five stars for a feedback rating, announced by `label`. */
export function StarRow({ value, label, className }: StarRowProps) {
  const filledThrough = Math.round(value);
  return (
    <div className="flex gap-0.5" role="img" aria-label={label}>
      {RATINGS.map((rating) => (
        <Star
          key={rating}
          aria-hidden="true"
          className={cn(
            "size-4",
            rating <= filledThrough ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40",
            className,
          )}
        />
      ))}
    </div>
  );
}
